import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmptyState, FlexBox, Spinner } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import styles from './searchResultsLoading.module.scss';
export const SearchResultsLoading = ({ isOverlay = false, }) => {
    return (_jsxs(FlexBox, Object.assign({ className: classNames(styles.root, {
            [styles.rootOverlaid]: isOverlay,
        }), flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: "400" }, { children: [_jsx(Spinner, {}), _jsx(EmptyState, { title: "Searching...", description: "Please wait a moment", icon: null })] })));
};
